import { MutationTree } from "vuex";
import { IPropertyEditState } from "../property-states.store";
import propertyRoomTypesStore from "./property-room-types.store";
import { IPropertyRoomModel } from "../../../../models/property";
import { itemStateConstant } from "../../../../common";
import Vue from "vue";
import { deepClone } from "fast-json-patch/lib/core";
import { DataHelper } from "../../../../utils/data-helper";

const roomMutations: MutationTree<IPropertyEditState> = <MutationTree<IPropertyEditState>>{
	[propertyRoomTypesStore.Set.LIST_OF_ROOMS]: (state: IPropertyEditState, listOfRooms: IPropertyRoomModel[]) => {
		state.property.Rooms = listOfRooms;
	}
	, [propertyRoomTypesStore.Set.ASSIGNVALUE_ROOM]: (state: IPropertyEditState, payload: { [key: string]: any }) => {
		const keys = Object.keys(payload);
        if (payload.ItemState !== itemStateConstant.Added && payload.ItemState !== itemStateConstant.Deleted) {
            state.currentRoom.ItemState = itemStateConstant.Modified;
        }

        keys.forEach(key => Vue.set(state.currentRoom, key, payload[key]));
        if (!state.property.Rooms) { return; }
        const roomIndex = state.property.Rooms.findIndex(x => (x.Id === state.currentRoom.Id && x.Id !== undefined) || (x.TempId === state.currentRoom.TempId && x.TempId !== undefined));
        if (roomIndex > -1) {
            state.property.Rooms[roomIndex] = deepClone(state.currentRoom);
        }
	}
	, [propertyRoomTypesStore.Set.ADD_TO_LIST]: (state: IPropertyEditState, room: IPropertyRoomModel) => {
        //room.ItemState = itemStateConstant.Added;
		if (!state.property.Rooms) {
			Vue.set(state.property, 'Rooms', []);
		}
		state.property.Rooms.push(room);
	}
	, [propertyRoomTypesStore.Set.CURRENT_ROOM]: (state: IPropertyEditState, room: IPropertyRoomModel) => {
        state.currentRoom = deepClone(room);
	}
	, [propertyRoomTypesStore.Set.ROOM_INDEXES]: (state: IPropertyEditState, payload: { list, oldRoomOrderNr: number, newRoomOrderNr: number }) => {
        const newIndex = payload.list.findIndex(x => x.OrderNr === payload.newRoomOrderNr);
        const oldIndex = payload.list.findIndex(x => x.OrderNr === payload.oldRoomOrderNr);
        
        // sort, shift item
        DataHelper.insertAndShift(payload.list, oldIndex, newIndex);
        payload.list.forEach((room, i) => {
            if (room.ItemState != itemStateConstant.Added) {
                room.ItemState = itemStateConstant.Modified;
            }
            if (!state.property.Rooms) { return; }
            const index = room.Id ? state.property.Rooms.findIndex(x => x.Id === room.Id) : state.property.Rooms.findIndex(x => x.TempId === room.TempId);
            // Update new order base on index.
            room.OrderNr = i;
            state.property.Rooms[index] = deepClone(room);
        });
	}
}

export default roomMutations;